import React, { useState } from 'react';
import { Dropdown, Input } from 'antd';
import {
    UserPlus,
    Trash2,
    Edit3,
    Plus,
    Search,
    Filter,
    List as ListIcon,
    LayoutGrid,
    Flag,
    Clock,
    MinusCircle,
    Loader,
    AlertTriangle,
    CheckCircle2
} from 'lucide-react';
import Layout from '../../Layout'
import { Link } from 'react-router-dom';

// --- MOCK DATA ---
const mockData = [
    {
        id: 1,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'success', // success, pending, warning, rejected
        type: 'Nghỉ bù',
        startTime: 'Thứ 2, 11/5/2024 - 08:30 am',
        endTime: 'Thứ 2, 11/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Vương Anh', avatar: 'https://i.pravatar.cc/150?u=1' },
        timeAgo: '2 giờ trước',
        flagged: true,
    },
    {
        id: 2,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'pending',
        type: 'Công tác - Miền Trung',
        startTime: 'Thứ 2, 16/5/2024 - 08:30 am',
        endTime: 'Thứ 2, 16/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Thạch Phá Thiên', avatar: 'https://i.pravatar.cc/150?u=2' },
        timeAgo: '2 giờ trước',
        flagged: true,
    },
    {
        id: 3,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'warning',
        type: 'Nghỉ phép',
        startTime: 'Thứ 4, 22/5/2024 - 08:30 am',
        endTime: 'Thứ 3, 28/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Lăng Hàn', avatar: 'https://i.pravatar.cc/150?u=3' },
        timeAgo: '2 giờ trước',
        flagged: false,
    },
    {
        id: 4,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'warning',
        type: 'Nghỉ phép',
        startTime: 'Thứ 4, 22/5/2024 - 08:30 am',
        endTime: 'Thứ 3, 28/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Bích Lạc Phượng', avatar: 'https://i.pravatar.cc/150?u=4' },
        timeAgo: '2 giờ trước',
        flagged: false,
    },
    {
        id: 5,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'warning',
        type: 'Nghỉ phép',
        startTime: 'Thứ 4, 22/5/2024 - 08:30 am',
        endTime: 'Thứ 4, 22/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Đại Hắc', avatar: 'https://i.pravatar.cc/150?u=5' },
        timeAgo: '2 giờ trước',
        flagged: false,
    },
    {
        id: 6,
        title: 'Đơn xin nghỉ phép',
        status: 'Đã duyệt',
        statusType: 'success',
        type: 'Nghỉ bù',
        startTime: 'Thứ 2, 11/5/2024 - 08:30 am',
        endTime: 'Thứ 2, 11/5/2024 - 18:00 pm',
        reason: 'Xin nghỉ phép để khám bệnh',
        user: { name: 'Lăng Vân', avatar: 'https://i.pravatar.cc/150?u=6' },
        timeAgo: '2 giờ trước',
        flagged: false,
    }
];

const tabs = [
    { key: 'all', label: 'Tất cả', count: 10, color: 'text-blue-600', bg: 'bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400' },
    { key: 'pending', label: 'Chờ xử lý', count: 1, icon: <Loader className="w-4 h-4 text-orange-500" />, bg: 'bg-gray-100 dark:bg-gray-800' },
    { key: 'postponed', label: 'Hoãn lại', count: 3, icon: <AlertTriangle className="w-4 h-4 text-orange-400" />, bg: 'bg-gray-100 dark:bg-gray-800' },
    { key: 'rejected', label: 'Từ chối', count: 1, icon: <MinusCircle className="w-4 h-4 text-red-500" />, bg: 'bg-gray-100 dark:bg-gray-800' },
    { key: 'completed', label: 'Hoàn tất', count: 5, icon: <CheckCircle2 className="w-4 h-4 text-green-500" />, bg: 'bg-gray-100 dark:bg-gray-800' },
];

const createMenuItems = [
    { key: '1', label: <Link to="/request/add">Form mẫu</Link> },
    { key: '2', label: 'Tuỳ chỉnh' },
];

export default function RequestManagement() {
    const [viewMode, setViewMode] = useState('grid'); // 'grid' | 'list'
    const [activeTab, setActiveTab] = useState('all');

    // Helper render icon status for list view
    const renderStatusIcon = (type) => {
        switch (type) {
            case 'rejected': return <MinusCircle className="w-5 h-5 text-red-500" />;
            case 'pending': return <Loader className="w-5 h-5 text-orange-500" />;
            case 'warning': return <AlertTriangle className="w-5 h-5 text-orange-400" />;
            case 'success': return <CheckCircle2 className="w-5 h-5 text-green-500" />;
            default: return <CheckCircle2 className="w-5 h-5 text-green-500" />;
        }
    };

    return (
        <Layout>

            {/* HEADER */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4 text-000000e0">
                <div className="flex items-center text-lg font-medium">
                    <span className="text-gray-500 dark:text-gray-400">Yêu cầu</span>
                    <span className="mx-2 text-gray-400">»</span>
                    <span>Tất cả (10)</span>
                </div>

                <div className="flex items-center gap-3">
                    <button className="p-2 text-blue-600 hover:bg-blue-50 dark:hover:bg-gray-800 rounded-md transition-colors">
                        <UserPlus className="w-5 h-5" />
                    </button>
                    <button className="p-2 text-blue-600 hover:bg-blue-50 dark:hover:bg-gray-800 rounded-md transition-colors">
                        <Trash2 className="w-5 h-5" />
                    </button>
                    <button className="p-2 text-blue-600 hover:bg-blue-50 dark:hover:bg-gray-800 rounded-md transition-colors">
                        <Edit3 className="w-5 h-5" />
                    </button>
                    <Dropdown menu={{ items: createMenuItems }} placement="bottomRight" arrow>
                        <button className="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-colors">
                            <Plus className="w-4 h-4" />
                            <span>Tạo mới</span>
                        </button>
                    </Dropdown>
                </div>
            </div>

            {/* FILTER & SEARCH */}
            <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 p-4 mb-6">
                <div className="flex items-center gap-2 mb-4">
                    <Input
                        prefix={<Search className="w-4 h-4 text-gray-400" />}
                        placeholder="Tìm kiếm"
                        className="w-full dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:placeholder-gray-500 rounded-md h-10"
                    />
                    <button className="p-2 border border-gray-200 dark:border-gray-700 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                        <Filter className="w-5 h-5 text-gray-500 dark:text-gray-400" />
                    </button>
                </div>

                {/* TABS & VIEW TOGGLE */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-gray-200 dark:border-gray-800">
                    <div className="flex overflow-x-auto w-full md:w-auto hide-scrollbar gap-6">
                        {tabs.map((tab) => (
                            <div
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`flex items-center gap-2 pb-3 cursor-pointer whitespace-nowrap border-b-2 transition-colors
                  ${activeTab === tab.key ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-blue-500'}`}
                            >
                                {tab.icon && <span>{tab.icon}</span>}
                                <span className="font-medium">{tab.label}</span>
                                <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${tab.bg} ${tab.key === 'all' && activeTab === 'all' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-300'}`}>
                                    {tab.count}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className="flex items-center gap-2 mt-4 md:mt-0 pb-3">
                        <button
                            onClick={() => setViewMode('list')}
                            className={`p-1.5 rounded-md transition-colors ${viewMode === 'list' ? 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                        >
                            <ListIcon className="w-5 h-5" />
                        </button>
                        <button
                            onClick={() => setViewMode('grid')}
                            className={`p-1.5 rounded-md transition-colors ${viewMode === 'grid' ? 'bg-blue-50 dark:bg-blue-900/40 text-blue-600' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                        >
                            <LayoutGrid className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>

            {/* CONTENT AREA */}
            {viewMode === 'grid' ? (
                // --- GRID VIEW ---
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {mockData.map((item) => (
                        <div key={item.id} className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow relative">
                            <div className="flex justify-between items-start mb-4">
                                <div className="flex items-center gap-2">
                                    <Flag className="w-4 h-4 text-red-500 fill-red-500" />
                                    <span className="font-semibold text-gray-800 dark:text-gray-100">{item.title}</span>
                                    <span className="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
                                        {item.status}
                                    </span>
                                </div>
                                {item.flagged && <Flag className="w-4 h-4 text-red-500 fill-red-500" />}
                            </div>

                            <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400 mb-6">
                                <p><span className="text-gray-400 dark:text-gray-500">Thời gian bắt đầu:</span> {item.startTime}</p>
                                <p><span className="text-gray-400 dark:text-gray-500">Thời gian kết thúc:</span> {item.endTime}</p>
                                <p><span className="text-gray-400 dark:text-gray-500">Lý do:</span> {item.reason}</p>
                            </div>

                            <div className="flex items-center justify-between mt-auto">
                                <div className="flex items-center gap-2">
                                    <img src={item.user.avatar} alt="avatar" className="w-6 h-6 rounded-full object-cover" />
                                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{item.user.name}</span>
                                </div>
                                <div className="flex items-center gap-1 text-gray-400 text-xs">
                                    <Clock className="w-3.5 h-3.5" />
                                    <span>{item.timeAgo}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                // --- LIST VIEW ---
                <div className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden">
                    <div className="flex flex-col">
                        {mockData.map((item, index) => (
                            <div
                                key={item.id}
                                className={`flex flex-col md:flex-row items-start md:items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors
                  ${index !== mockData.length - 1 ? 'border-b border-gray-100 dark:border-gray-800' : ''}`}
                            >
                                <div className="flex items-center gap-4 md:w-1/4">
                                    {renderStatusIcon(item.statusType)}
                                    <div className="flex items-center gap-2">
                                        <img src={item.user.avatar} alt="avatar" className="w-8 h-8 rounded-full object-cover" />
                                        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">{item.user.name}</span>
                                    </div>
                                </div>

                                <div className="md:w-1/5 text-sm font-medium text-blue-600 dark:text-blue-400 cursor-pointer">
                                    {item.title}
                                </div>

                                <div className="md:w-1/6 text-sm text-gray-600 dark:text-gray-400">
                                    {item.type}
                                </div>

                                <div className="md:flex-1 text-sm text-gray-600 dark:text-gray-400">
                                    {item.startTime.split(' - ')[0]} - {item.endTime.split(' - ')[0]}
                                </div>

                                <div className="flex items-center gap-4 md:w-32 justify-end">
                                    <div className="flex items-center gap-1 text-gray-400 text-xs whitespace-nowrap">
                                        <Clock className="w-3.5 h-3.5" />
                                        <span>2 giờ</span>
                                    </div>
                                    {item.flagged ? (
                                        <Flag className="w-4 h-4 text-red-500 fill-red-500" />
                                    ) : (
                                        <Flag className="w-4 h-4 text-blue-500 fill-blue-500" />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </Layout>
    );
}